var _g, _g2, _g3, _g4, _path, _path2, _path3, _path4, _path5, _path6, _path7, _g5, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _g6, _g7, _g8, _g9, _g10, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlaceholderLicenses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 189,
    height: 158,
    viewBox: "0 0 189 158",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.08 114.146C176.08 99.9676 176.08 85.7958 176.08 71.6241C176.08 70.3123 175.02 69.2456 173.701 69.2456C150.161 69.2456 126.608 69.2456 103.061 69.2456C102.505 69.2456 102.068 69.3914 101.624 69.7293L99.5764 71.2796C99.5697 71.2862 99.5697 71.2862 99.5631 71.2929C98.9933 71.7235 98.6223 72.4125 98.6223 73.1877C98.6223 87.3528 98.6223 101.531 98.6223 115.703C98.6223 117.015 99.6824 118.081 101.001 118.081C124.547 118.081 148.094 118.081 171.647 118.081C172.184 118.081 172.681 117.903 173.079 117.598C173.105 117.578 173.132 117.558 173.158 117.538L175.139 116.034C175.735 115.59 176.08 114.888 176.08 114.146Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.285 51.8937C131.285 37.722 131.285 23.5502 131.285 9.37852C131.285 8.06669 130.219 7 128.907 7C105.36 7 81.8136 7 58.2669 7C57.7104 7 57.2731 7.14576 56.8292 7.48365L55.8023 8.26545L54.7819 9.034C54.2055 9.46465 53.8279 10.1603 53.8279 10.9355C53.8279 25.1072 53.8279 39.2856 53.8279 53.4506C53.8279 54.7691 54.8879 55.8292 56.1998 55.8292C79.7531 55.8292 103.3 55.8292 126.846 55.8292C127.383 55.8292 127.88 55.6503 128.284 55.3455V55.3521L130.345 53.7885C130.934 53.338 131.285 52.6357 131.285 51.8937Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.4575 127.556C85.4575 113.391 85.4575 99.2123 85.4575 85.0406C85.4575 83.7288 84.3908 82.6687 83.079 82.6687C59.5323 82.6687 35.9857 82.6687 12.439 82.6687C11.8825 82.6687 11.4452 82.8145 11.0013 83.1457L9.04681 84.6298C9.03356 84.6364 9.02694 84.6431 9.01369 84.6497L8.94081 84.7093C8.37102 85.14 8 85.829 8 86.5976C8 100.776 8 114.948 8 129.119C8 130.431 9.06669 131.498 10.3719 131.498C33.9252 131.498 57.4718 131.498 81.0185 131.498C81.5551 131.498 82.0521 131.319 82.4496 131.014L84.5167 129.457C85.1064 129.007 85.4575 128.304 85.4575 127.556Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.246 78.3953C148.246 78.773 148.167 79.1307 148.021 79.462C147.895 79.4819 147.776 79.4885 147.657 79.4885C141.475 79.4885 135.294 79.4885 129.112 79.4885C127.198 79.4885 125.906 77.5208 126.681 75.765C126.807 75.7452 126.926 75.7385 127.052 75.7385C133.227 75.7385 139.408 75.7385 145.59 75.7385C147.06 75.7385 148.246 76.9245 148.246 78.3953Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.452 16.1431C103.452 16.5274 103.372 16.8852 103.227 17.2164C103.101 17.2297 102.982 17.2363 102.856 17.2363C96.6742 17.2363 90.4927 17.2363 84.3112 17.2363C82.3965 17.2363 81.1111 15.2686 81.8863 13.5128C82.0056 13.493 82.1248 13.4863 82.2507 13.4863C88.4322 13.4863 94.6137 13.4863 100.795 13.4863C102.259 13.4863 103.452 14.6789 103.452 16.1431Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.624 91.8118C57.624 92.1895 57.5445 92.5539 57.3988 92.8785C57.2795 92.8984 57.1536 92.905 57.0277 92.905C50.8462 92.905 44.6648 92.905 38.4899 92.905C36.5685 92.905 35.2832 90.9373 36.0584 89.1815C36.1776 89.1617 36.3035 89.155 36.4294 89.155C42.6043 89.155 48.7858 89.155 54.9672 89.155C56.4381 89.155 57.624 90.341 57.624 91.8118Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M176.08 71.6241C176.08 85.7959 176.08 99.9676 176.08 114.146C176.08 114.888 175.735 115.59 175.139 116.041L173.151 117.545C173.681 117.107 174.019 116.452 174.019 115.71C174.019 101.538 174.019 87.3594 174.019 73.1877C174.019 71.8759 172.952 70.8092 171.641 70.8092C148.094 70.8092 124.541 70.8092 100.994 70.8092C100.457 70.8092 99.9671 70.9881 99.5762 71.2796L101.623 69.7293C102.067 69.398 102.505 69.2456 103.061 69.2456C126.608 69.2456 150.161 69.2456 173.701 69.2456C175.02 69.2456 176.08 70.3057 176.08 71.6241Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M126.681 75.7585C125.389 75.9374 124.395 77.0438 124.395 78.3888C124.395 79.853 125.581 81.0389 127.052 81.0389C133.227 81.0389 139.408 81.0389 145.59 81.0389C146.676 81.0389 147.61 80.3897 148.021 79.4555C148.167 79.1242 148.246 78.7664 148.246 78.3888C148.246 76.9179 147.054 75.732 145.59 75.732C139.408 75.732 133.227 75.732 127.052 75.732C126.926 75.732 126.807 75.7452 126.681 75.7585ZM174.019 73.1812C174.019 87.3529 174.019 101.525 174.019 115.703C174.019 116.438 173.681 117.101 173.151 117.538C173.125 117.558 173.098 117.578 173.072 117.598C172.674 117.903 172.177 118.082 171.641 118.082C148.094 118.082 124.541 118.082 100.994 118.082C99.6822 118.082 98.6155 117.015 98.6155 115.703C98.6155 101.531 98.6155 87.3529 98.6155 73.1812C98.6155 72.406 98.9865 71.717 99.5563 71.2864C99.5563 71.2864 99.5629 71.2797 99.5695 71.2797C99.9604 70.9816 100.457 70.8093 100.987 70.8093C124.534 70.8093 148.087 70.8093 171.634 70.8093C172.952 70.8093 174.019 71.8694 174.019 73.1812ZM164.684 100.736C164.684 99.9544 164.684 99.166 164.684 98.3842C164.684 98.053 164.412 97.7879 164.088 97.7879C154.183 97.7879 144.278 97.7879 134.373 97.7879C134.041 97.7879 133.776 98.053 133.776 98.3842C133.776 99.166 133.776 99.9544 133.776 100.736C133.776 101.068 134.041 101.333 134.373 101.333C144.278 101.333 154.176 101.333 164.088 101.333C164.419 101.333 164.684 101.068 164.684 100.736ZM164.684 92.6466C164.684 91.8648 164.684 91.0764 164.684 90.2946C164.684 89.9633 164.412 89.6983 164.088 89.6983C154.183 89.6983 144.278 89.6983 134.373 89.6983C134.041 89.6983 133.776 89.9633 133.776 90.2946C133.776 91.0764 133.776 91.8648 133.776 92.6466C133.776 92.9779 134.041 93.2429 134.373 93.2429C144.278 93.2429 154.176 93.2429 164.088 93.2429C164.419 93.2429 164.684 92.9779 164.684 92.6466ZM149.83 108.826C149.83 108.044 149.83 107.256 149.83 106.474C149.83 106.143 149.565 105.878 149.234 105.878H134.379C134.048 105.878 133.783 106.143 133.783 106.474V108.826C133.783 109.157 134.048 109.422 134.379 109.422H149.234C149.565 109.422 149.83 109.157 149.83 108.826ZM130.053 109.422C130.053 102.85 130.053 96.2773 130.053 89.6983C130.053 89.0424 129.523 88.5124 128.867 88.5124C122.295 88.5124 115.722 88.5124 109.143 88.5124C108.487 88.5124 107.957 89.0424 107.957 89.6983C107.957 96.2707 107.957 102.843 107.957 109.422C107.957 110.078 108.487 110.608 109.143 110.608C109.488 110.608 109.826 110.608 110.17 110.608C116.06 110.608 121.95 110.608 127.84 110.608C128.178 110.608 128.523 110.608 128.867 110.608C129.523 110.608 130.053 110.078 130.053 109.422Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M164.684 98.3841C164.684 99.1659 164.684 99.9544 164.684 100.736C164.684 101.067 164.412 101.332 164.088 101.332C154.183 101.332 144.278 101.332 134.373 101.332C134.041 101.332 133.776 101.067 133.776 100.736C133.776 99.9544 133.776 99.1659 133.776 98.3841C133.776 98.0529 134.041 97.7878 134.373 97.7878C144.278 97.7878 154.176 97.7878 164.088 97.7878C164.419 97.7878 164.684 98.0595 164.684 98.3841Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M164.684 90.2945C164.684 91.0763 164.684 91.8647 164.684 92.6465C164.684 92.9778 164.412 93.2428 164.088 93.2428C154.183 93.2428 144.278 93.2428 134.373 93.2428C134.041 93.2428 133.776 92.9778 133.776 92.6465C133.776 91.8647 133.776 91.0763 133.776 90.2945C133.776 89.9633 134.041 89.6982 134.373 89.6982C144.278 89.6982 154.176 89.6982 164.088 89.6982C164.419 89.6982 164.684 89.9633 164.684 90.2945Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M149.83 106.474C149.83 107.256 149.83 108.044 149.83 108.826C149.83 109.157 149.565 109.422 149.234 109.422H134.379C134.048 109.422 133.783 109.157 133.783 108.826V106.474C133.783 106.142 134.048 105.877 134.379 105.877H149.234C149.565 105.877 149.83 106.142 149.83 106.474Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M147.657 79.482C147.776 79.482 147.895 79.4754 148.021 79.4555C147.61 80.3897 146.676 81.039 145.59 81.039C139.408 81.039 133.227 81.039 127.052 81.039C125.581 81.039 124.395 79.853 124.395 78.3888C124.395 77.0439 125.389 75.9374 126.681 75.7585C125.906 77.5143 127.191 79.482 129.112 79.482C135.294 79.482 141.475 79.482 147.657 79.482Z",
    fill: "url(#paint2_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M130.053 89.6984C130.053 96.2708 130.053 102.843 130.053 109.422C130.053 110.078 129.523 110.608 128.867 110.608C128.529 110.608 128.184 110.608 127.84 110.608C127.085 106.322 123.354 103.194 119.002 103.194C114.649 103.194 110.925 106.322 110.17 110.608C109.825 110.608 109.488 110.608 109.143 110.608C108.487 110.608 107.957 110.078 107.957 109.422C107.957 102.85 107.957 96.2774 107.957 89.6984C107.957 89.0425 108.487 88.5125 109.143 88.5125C115.715 88.5125 122.294 88.5125 128.867 88.5125C129.523 88.5125 130.053 89.0425 130.053 89.6984ZM122.599 99.5371C123.719 97.5495 123.017 95.0385 121.029 93.9188C119.041 92.8057 116.53 93.508 115.411 95.489C114.291 97.47 115 99.9876 116.981 101.107C118.962 102.227 121.479 101.518 122.599 99.5371Z",
    fill: "white"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M127.84 110.608C121.95 110.608 116.06 110.608 110.17 110.608C110.925 106.322 114.656 103.194 119.002 103.194C123.361 103.201 127.085 106.322 127.84 110.608Z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M121.029 93.9188C123.017 95.0385 123.719 97.5495 122.6 99.5371C121.487 101.525 118.969 102.227 116.988 101.107C115.007 99.9877 114.298 97.4766 115.418 95.489C116.537 93.5014 119.042 92.7991 121.029 93.9188Z",
    fill: "url(#paint4_linear)"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M131.285 9.37189C131.285 23.5436 131.285 37.7153 131.285 51.8937C131.285 52.6357 130.934 53.338 130.344 53.7885L128.284 55.3521C128.854 54.9215 129.225 54.2324 129.225 53.4573C129.225 39.2856 129.225 25.1138 129.225 10.9421C129.225 9.63028 128.165 8.56359 126.846 8.56359C103.299 8.56359 79.7528 8.56359 56.2062 8.56359C55.6695 8.56359 55.1792 8.74248 54.7883 9.034L55.8086 8.26545L56.8356 7.48365C57.2795 7.15238 57.7168 7 58.2733 7C81.8199 7 105.367 7 128.913 7C130.218 7 131.285 8.06006 131.285 9.37189Z",
    fill: "url(#paint5_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M129.218 10.9356C129.218 25.1074 129.218 39.2791 129.218 53.4508C129.218 54.226 128.847 54.9084 128.277 55.3457C127.88 55.6504 127.383 55.8293 126.84 55.8293C103.293 55.8293 79.7465 55.8293 56.1998 55.8293C54.888 55.8293 53.8213 54.7693 53.8213 53.4508C53.8213 39.2791 53.8213 25.1074 53.8213 10.9356C53.8213 10.1538 54.1989 9.4648 54.7753 9.03415C55.1662 8.73601 55.6631 8.56375 56.1932 8.56375C79.7398 8.56375 103.293 8.56375 126.833 8.56375C128.158 8.55713 129.218 9.62381 129.218 10.9356ZM119.89 38.4907C119.89 37.7089 119.89 36.9204 119.89 36.1387C119.89 35.8074 119.625 35.5424 119.293 35.5424C109.388 35.5424 99.4901 35.5424 89.5852 35.5424C89.2539 35.5424 88.9889 35.8074 88.9889 36.1387C88.9889 36.9204 88.9889 37.7089 88.9889 38.4907C88.9889 38.8219 89.2539 39.087 89.5852 39.087C99.4901 39.087 109.388 39.087 119.293 39.087C119.625 39.0803 119.89 38.8153 119.89 38.4907ZM119.89 30.4011C119.89 29.6193 119.89 28.8308 119.89 28.049C119.89 27.7178 119.625 27.4528 119.293 27.4528C109.388 27.4528 99.4901 27.4528 89.5852 27.4528C89.2539 27.4528 88.9889 27.7178 88.9889 28.049C88.9889 28.8308 88.9889 29.6193 88.9889 30.4011C88.9889 30.7323 89.2539 30.9973 89.5852 30.9973C99.4901 30.9973 109.388 30.9973 119.293 30.9973C119.625 30.9907 119.89 30.7257 119.89 30.4011ZM105.036 46.5803C105.036 45.7985 105.036 45.0101 105.036 44.2283C105.036 43.897 104.771 43.632 104.439 43.632H89.5852C89.2539 43.632 88.9889 43.897 88.9889 44.2283V46.5803C88.9889 46.9115 89.2539 47.1766 89.5852 47.1766H104.439C104.771 47.1766 105.036 46.9115 105.036 46.5803ZM103.227 17.2099C103.373 16.8786 103.452 16.5209 103.452 16.1366C103.452 14.6724 102.26 13.4798 100.795 13.4798C94.6138 13.4798 88.4324 13.4798 82.2509 13.4798C82.125 13.4798 82.0057 13.4864 81.8865 13.5063C80.5945 13.6852 79.6007 14.7982 79.6007 16.1366C79.6007 17.6074 80.7866 18.7934 82.2509 18.7934C88.4324 18.7934 94.6138 18.7934 100.795 18.7934C101.882 18.8 102.816 18.1441 103.227 17.2099ZM85.2588 47.1766C85.2588 40.6042 85.2588 34.0251 85.2588 27.4528C85.2588 26.7968 84.7288 26.2668 84.0728 26.2668C77.5005 26.2668 70.9281 26.2668 64.349 26.2668C63.6931 26.2668 63.1631 26.7968 63.1631 27.4528C63.1631 34.0251 63.1631 40.5975 63.1631 47.1766C63.1631 47.8325 63.6931 48.3625 64.349 48.3625C64.6869 48.3625 65.0315 48.3625 65.376 48.3625C71.266 48.3625 77.1559 48.3625 83.0525 48.3625C83.3904 48.3625 83.7349 48.3625 84.0795 48.3625C84.7288 48.3625 85.2588 47.8325 85.2588 47.1766Z",
    fill: "url(#paint6_linear)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M119.89 36.1319C119.89 36.9137 119.89 37.7021 119.89 38.4839C119.89 38.8152 119.625 39.0802 119.293 39.0802C109.388 39.0802 99.49 39.0802 89.5851 39.0802C89.2538 39.0802 88.9888 38.8152 88.9888 38.4839C88.9888 37.7021 88.9888 36.9137 88.9888 36.1319C88.9888 35.8007 89.2538 35.5356 89.5851 35.5356C99.49 35.5356 109.388 35.5356 119.293 35.5356C119.625 35.5423 119.89 35.8073 119.89 36.1319Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M119.89 28.0489C119.89 28.8307 119.89 29.6191 119.89 30.4009C119.89 30.7322 119.625 30.9972 119.293 30.9972C109.388 30.9972 99.49 30.9972 89.5851 30.9972C89.2538 30.9972 88.9888 30.7322 88.9888 30.4009C88.9888 29.6191 88.9888 28.8307 88.9888 28.0489C88.9888 27.7177 89.2538 27.4526 89.5851 27.4526C99.49 27.4526 109.388 27.4526 119.293 27.4526C119.625 27.4526 119.89 27.7177 119.89 28.0489Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M105.035 44.2281C105.035 45.0099 105.035 45.7983 105.035 46.5801C105.035 46.9114 104.77 47.1764 104.439 47.1764H89.5851C89.2538 47.1764 88.9888 46.9114 88.9888 46.5801V44.2281C88.9888 43.8969 89.2538 43.6318 89.5851 43.6318H104.439C104.77 43.6318 105.035 43.8969 105.035 44.2281Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M102.856 17.2364C102.975 17.2364 103.101 17.2298 103.22 17.2099C102.809 18.1441 101.875 18.7934 100.788 18.7934C94.6069 18.7934 88.4254 18.7934 82.2439 18.7934C80.7797 18.7934 79.5938 17.6075 79.5938 16.1366C79.5938 14.7983 80.5876 13.6852 81.8795 13.5063C81.1043 15.2621 82.3897 17.2298 84.311 17.2298C90.4925 17.2364 96.674 17.2364 102.856 17.2364Z",
    fill: "url(#paint7_linear)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2588 27.4528C85.2588 34.0252 85.2588 40.5976 85.2588 47.1766C85.2588 47.8325 84.7288 48.3625 84.0729 48.3625C83.735 48.3625 83.3905 48.3625 83.0459 48.3625C82.2906 44.0759 78.5605 40.9487 74.2077 40.9487C69.8548 40.9487 66.1313 44.0759 65.3694 48.3625C65.0315 48.3625 64.687 48.3625 64.3424 48.3625C63.6865 48.3625 63.1565 47.8325 63.1565 47.1766C63.1565 40.6042 63.1565 34.0252 63.1565 27.4528C63.1565 26.7969 63.6865 26.2668 64.3424 26.2668C70.9148 26.2668 77.4872 26.2668 84.0662 26.2668C84.7288 26.2668 85.2588 26.7969 85.2588 27.4528ZM77.8052 37.2849C78.9183 35.2973 78.2226 32.7862 76.235 31.6665C74.2474 30.5535 71.7364 31.2558 70.6233 33.2368C69.5036 35.2244 70.2059 37.7354 72.1935 38.8551C74.1745 39.9748 76.6856 39.2725 77.8052 37.2849Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M83.0457 48.3626C77.1557 48.3626 71.2657 48.3626 65.3691 48.3626C66.1244 44.0759 69.8545 40.9487 74.2074 40.9487C78.5603 40.9487 82.2904 44.0759 83.0457 48.3626Z",
    fill: "url(#paint8_linear)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M76.2283 31.6664C78.2159 32.7795 78.9182 35.2971 77.7985 37.2847C76.6854 39.2724 74.1678 39.9747 72.1802 38.855C70.1926 37.7419 69.4903 35.2242 70.61 33.2366C71.7296 31.2556 74.2473 30.5533 76.2283 31.6664Z",
    fill: "url(#paint9_linear)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M85.4576 85.0407C85.4576 99.2124 85.4576 113.384 85.4576 127.556C85.4576 128.305 85.1131 129 84.5168 129.451L82.4563 131.014C83.026 130.584 83.3971 129.895 83.3971 129.119C83.3971 114.948 83.3971 100.776 83.3971 86.5976C83.3971 85.2858 82.3304 84.2191 81.0186 84.2191C57.4719 84.2191 33.9186 84.2191 10.372 84.2191C9.88167 84.2191 9.42452 84.3715 9.04688 84.6233L11.008 83.1392C11.4519 82.8079 11.8825 82.6555 12.4391 82.6555C35.9857 82.6555 59.539 82.6555 83.0857 82.6555C84.3909 82.6621 85.4576 83.7288 85.4576 85.0407Z",
    fill: "url(#paint10_linear)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M83.397 86.5978C83.397 100.769 83.397 114.948 83.397 129.12C83.397 129.895 83.026 130.584 82.4562 131.014C82.0587 131.313 81.5618 131.498 81.0251 131.498C57.4785 131.498 33.9252 131.498 10.3785 131.498C9.06669 131.498 8 130.438 8 129.12C8 114.948 8 100.776 8 86.5978C8 85.8226 8.37102 85.1402 8.94081 84.7029L9.01369 84.6433C9.02031 84.6366 9.03356 84.63 9.04681 84.6234C9.42446 84.365 9.88824 84.2192 10.3719 84.2192C33.9185 84.2192 57.4718 84.2192 81.0185 84.2192C82.3303 84.2259 83.397 85.2859 83.397 86.5978ZM74.0618 114.153C74.0618 113.371 74.0618 112.583 74.0618 111.801C74.0618 111.469 73.7968 111.204 73.4655 111.204C63.5606 111.204 53.6556 111.204 43.7506 111.204C43.4194 111.204 43.1544 111.469 43.1544 111.801C43.1544 112.583 43.1544 113.371 43.1544 114.153C43.1544 114.484 43.4194 114.749 43.7506 114.749C53.6556 114.749 63.5606 114.749 73.4655 114.749C73.7968 114.749 74.0618 114.484 74.0618 114.153ZM74.0618 106.063C74.0618 105.281 74.0618 104.493 74.0618 103.711C74.0618 103.387 73.7968 103.121 73.4655 103.121C63.5606 103.121 53.6556 103.121 43.7506 103.121C43.4194 103.121 43.1544 103.387 43.1544 103.711C43.1544 104.493 43.1544 105.281 43.1544 106.063C43.1544 106.394 43.4194 106.659 43.7506 106.659C53.6556 106.659 63.5606 106.659 73.4655 106.659C73.7968 106.659 74.0618 106.394 74.0618 106.063ZM59.2077 122.249C59.2077 121.467 59.2077 120.679 59.2077 119.897C59.2077 119.566 58.9427 119.301 58.6114 119.301H43.7573C43.426 119.301 43.161 119.566 43.161 119.897V122.249C43.161 122.58 43.426 122.845 43.7573 122.845H58.6114C58.936 122.839 59.2077 122.574 59.2077 122.249ZM57.3989 92.8786C57.5447 92.554 57.6242 92.1896 57.6242 91.8119C57.6242 90.3477 56.4383 89.1552 54.9674 89.1552C48.7859 89.1552 42.6111 89.1552 36.4296 89.1552C36.3037 89.1552 36.1844 89.1618 36.0585 89.1817C34.7666 89.3605 33.7728 90.4736 33.7728 91.8119C33.7728 93.2828 34.9587 94.4687 36.4296 94.4687C42.6111 94.4687 48.7859 94.4687 54.9674 94.4687C56.054 94.4621 56.9882 93.8128 57.3989 92.8786ZM39.4309 122.839V103.115C39.4309 102.459 38.9008 101.929 38.2449 101.929C31.6725 101.929 25.1001 101.929 18.5211 101.929C17.8652 101.929 17.3352 102.459 17.3352 103.115C17.3352 109.687 17.3352 116.26 17.3352 122.839C17.3352 123.495 17.8652 124.025 18.5211 124.025C18.8656 124.025 19.2035 124.025 19.5481 124.025C25.438 124.025 31.328 124.025 37.218 124.025C37.5559 124.025 37.9004 124.025 38.2449 124.025C38.9008 124.031 39.4309 123.495 39.4309 122.839Z",
    fill: "url(#paint11_linear)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0618 111.801C74.0618 112.582 74.0618 113.371 74.0618 114.153C74.0618 114.484 73.7968 114.749 73.4655 114.749C63.5605 114.749 53.6555 114.749 43.7506 114.749C43.4193 114.749 43.1543 114.484 43.1543 114.153C43.1543 113.371 43.1543 112.582 43.1543 111.801C43.1543 111.469 43.4193 111.204 43.7506 111.204C53.6555 111.204 63.5605 111.204 73.4655 111.204C73.7968 111.204 74.0618 111.469 74.0618 111.801Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0618 103.711C74.0618 104.493 74.0618 105.281 74.0618 106.063C74.0618 106.394 73.7968 106.659 73.4655 106.659C63.5605 106.659 53.6555 106.659 43.7506 106.659C43.4193 106.659 43.1543 106.394 43.1543 106.063C43.1543 105.281 43.1543 104.493 43.1543 103.711C43.1543 103.386 43.4193 103.121 43.7506 103.121C53.6555 103.121 63.5605 103.121 73.4655 103.121C73.7968 103.121 74.0618 103.386 74.0618 103.711Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2076 119.89C59.2076 120.672 59.2076 121.46 59.2076 122.242C59.2076 122.574 58.9426 122.839 58.6113 122.839H43.7572C43.4259 122.839 43.1609 122.574 43.1609 122.242V119.89C43.1609 119.559 43.4259 119.294 43.7572 119.294H58.6113C58.936 119.301 59.2076 119.566 59.2076 119.89Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M57.0278 92.9051C57.1471 92.9051 57.273 92.8985 57.3989 92.8786C56.9881 93.8128 56.0539 94.4687 54.9673 94.4687C48.7858 94.4687 42.611 94.4687 36.4295 94.4687C34.9586 94.4687 33.7727 93.2828 33.7727 91.8119C33.7727 90.4736 34.7665 89.3605 36.0585 89.1816C35.2833 90.9374 36.5686 92.9051 38.49 92.9051C44.6649 92.9051 50.8463 92.9051 57.0278 92.9051Z",
    fill: "url(#paint12_linear)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4309 103.121V122.845C39.4309 123.501 38.9009 124.031 38.245 124.031C37.9071 124.031 37.5625 124.031 37.218 124.031C36.4627 119.744 32.7326 116.617 28.3797 116.617C24.0269 116.617 20.3034 119.738 19.5481 124.031C19.2036 124.031 18.8657 124.031 18.5212 124.031C17.8652 124.031 17.3352 123.494 17.3352 122.845C17.3352 116.273 17.3352 109.694 17.3352 103.121C17.3352 102.465 17.8652 101.935 18.5212 101.935C25.0935 101.935 31.6726 101.935 38.245 101.935C38.9009 101.929 39.4309 102.459 39.4309 103.121ZM31.9773 112.953C33.0904 110.966 32.3881 108.455 30.4071 107.335C28.4195 106.222 25.9085 106.924 24.7888 108.905C23.6691 110.886 24.378 113.404 26.359 114.524C28.3466 115.643 30.8576 114.934 31.9773 112.953Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M37.218 124.031C31.328 124.031 25.4381 124.031 19.5481 124.031C20.3034 119.744 24.0335 116.617 28.3797 116.617C32.7326 116.617 36.4561 119.738 37.218 124.031Z",
    fill: "url(#paint13_linear)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M30.4004 107.335C32.388 108.448 33.0903 110.966 31.9706 112.953C30.8509 114.941 28.3399 115.643 26.3523 114.524C24.3647 113.404 23.6624 110.893 24.7821 108.905C25.9018 106.918 28.4194 106.222 30.4004 107.335Z",
    fill: "url(#paint14_linear)"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter4_d)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M148.816 4H147.67V10.4863H148.816V4Z",
    fill: "url(#paint15_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M151.486 6.66992H145V7.81612H151.486V6.66992Z",
    fill: "url(#paint16_linear)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter5_d)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M28.3292 38H26.7285V47.0579H28.3292V38Z",
    fill: "url(#paint17_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M32.0579 41.7288H23V43.3294H32.0579V41.7288Z",
    fill: "url(#paint18_linear)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter6_d)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M128.152 134H126.905V141.058H128.152V134Z",
    fill: "url(#paint19_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M131.058 136.906H124V138.153H131.058V136.906Z",
    fill: "url(#paint20_linear)"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter7_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.1389 69.2895C44.2908 69.6208 43.3301 69.2696 42.9061 68.468C42.873 68.4083 42.8399 68.3487 42.7935 68.3023C42.4622 67.9313 41.8991 67.8982 41.528 68.2228C41.3028 68.4216 41.1901 68.7197 41.2365 69.0179C41.2431 69.0841 41.263 69.1504 41.2895 69.21C41.6208 70.0581 41.2696 71.0187 40.468 71.4428C40.4083 71.4759 40.3487 71.509 40.3023 71.5554C39.9313 71.8867 39.8982 72.4498 40.2228 72.8209C40.4216 73.0461 40.7197 73.1588 41.0179 73.1124C41.0841 73.1057 41.1504 73.0859 41.21 73.0594C42.0581 72.7281 43.0187 73.0792 43.4428 73.8809C43.4759 73.9405 43.509 74.0002 43.5554 74.0466C43.8867 74.4176 44.4498 74.4507 44.8209 74.1261C45.0461 73.9273 45.1588 73.6292 45.1124 73.331C45.1057 73.2648 45.0859 73.1985 45.0594 73.1389C44.7281 72.2908 45.0792 71.3301 45.8809 70.9061C45.9405 70.873 46.0002 70.8399 46.0466 70.7935C46.4176 70.4622 46.4507 69.8991 46.1261 69.528C45.9273 69.3028 45.6292 69.1901 45.331 69.2365C45.2714 69.2431 45.2051 69.263 45.1389 69.2895Z",
    fill: "url(#paint21_linear)"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter8_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170.5 52C172.433 52 174 50.433 174 48.5C174 46.567 172.433 45 170.5 45C168.567 45 167 46.567 167 48.5C167 50.433 168.567 52 170.5 52Z",
    fill: "#D0D4DF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 3,
    width: 188.08,
    height: 144.498,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.2 0 0 0 0 0.576471 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i",
    x: 125.452,
    y: 73.7385,
    width: 22.7943,
    height: 5.74997,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.2 0 0 0 0 0.576471 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i",
    x: 80.657,
    y: 11.4863,
    width: 22.795,
    height: 5.74997,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.2 0 0 0 0 0.576471 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i",
    x: 34.8291,
    y: 87.155,
    width: 22.7949,
    height: 5.74998,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.2 0 0 0 0 0.576471 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d",
    x: 137,
    y: 0,
    width: 26.4863,
    height: 26.4863,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.2 0 0 0 0 0.576471 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d",
    x: 15,
    y: 34,
    width: 29.0579,
    height: 29.0579,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.2 0 0 0 0 0.576471 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d",
    x: 116,
    y: 130,
    width: 27.0579,
    height: 27.0579,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.2 0 0 0 0 0.576471 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d",
    x: 32,
    y: 64,
    width: 26.3489,
    height: 26.3489,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.2 0 0 0 0 0.576471 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d",
    x: 159,
    y: 41,
    width: 27,
    height: 27,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.2 0 0 0 0 0.576471 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 99.5778,
    y1: 93.39,
    x2: 176.079,
    y2: 93.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 98.6228,
    y1: 94.4422,
    x2: 174.02,
    y2: 94.4422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 124.395,
    y1: 78.4029,
    x2: 148.021,
    y2: 78.4029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 110.17,
    y1: 106.905,
    x2: 127.842,
    y2: 106.905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 114.881,
    y1: 97.512,
    x2: 123.13,
    y2: 97.512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 54.7816,
    y1: 31.1727,
    x2: 131.283,
    y2: 31.1727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 53.8268,
    y1: 32.1936,
    x2: 129.221,
    y2: 32.1936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 79.5986,
    y1: 16.1543,
    x2: 103.225,
    y2: 16.1543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 65.3711,
    y1: 44.6574,
    x2: 83.0459,
    y2: 44.6574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 70.083,
    y1: 35.2647,
    x2: 78.3327,
    y2: 35.2647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 9.04562,
    y1: 106.839,
    x2: 85.4547,
    y2: 106.839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 7.99795,
    y1: 107.858,
    x2: 83.3953,
    y2: 107.858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 33.77,
    y1: 91.8203,
    x2: 57.3992,
    y2: 91.8203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 19.5454,
    y1: 120.323,
    x2: 37.2174,
    y2: 120.323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 24.2564,
    y1: 110.931,
    x2: 32.5063,
    y2: 110.931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x1: 147.668,
    y1: 7.24412,
    x2: 148.812,
    y2: 7.24412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear",
    x1: 144.997,
    y1: 7.24255,
    x2: 151.486,
    y2: 7.24255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear",
    x1: 26.7258,
    y1: 42.5303,
    x2: 28.323,
    y2: 42.5303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear",
    x1: 22.9964,
    y1: 42.5284,
    x2: 32.0571,
    y2: 42.5284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear",
    x1: 126.903,
    y1: 137.53,
    x2: 128.148,
    y2: 137.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear",
    x1: 123.997,
    y1: 137.529,
    x2: 131.057,
    y2: 137.529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear",
    x1: 40.8756,
    y1: 73.4781,
    x2: 45.4838,
    y2: 68.8699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholderLicenses);
export default __webpack_public_path__ + "static/media/placeholder_licenses.0e03e01602a2ad5067469f0c718f6069.svg";
export { ForwardRef as ReactComponent };